import { apiFetch } from './client';

export const sendChat = (systemId, message, history = []) =>
  apiFetch(`/ai/chat?system_id=${systemId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, history }),
  });
